import React, { useEffect } from 'react';

const SentryError: React.FC = () => {
    useEffect(() => {
        throw new Error('Test error!');
    }, []);

    return (
        <div>
            <h2>Sentry Error Test</h2>
            <p>This component throws an error on load to test Sentry integration.</p>
        </div>
    );
};

export default SentryError;
